export enum NotificationType {
  NEW_ACTIVITY = 'new activity',
  APPROVE_ACTIVITY = 'approve activity',
  GIFT = 'gift',
  CHALLENGED = 'challenged',
  EARNED = 'earned',
  COMPETITION_APPROVE = 'competition approve',
  OUT_OF_STOCK = 'out of stock',
}
